import { Stack, Typography, IconButton, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useCallback } from "react";
import CasesListTable from "./cases-list-table";

export const NeedUnassignedList = ({
  data,
  setData,
  handleBack,
  unassign,
  unassigning,
  onRemoveCaseSelection,
}) => {
  useEffect(() => {
    return () => {
      setData(new Map());
    };
  }, [setData]);

  const handleUnassign = () => {
    unassign();
  };

  const handleRemoveSelectedCase = (id, motherID) => {
    console.log("methods", onRemoveCaseSelection);

    onRemoveCaseSelection(id, motherID);
    setData((prevData) => {
      const newData = new Map(prevData);
      newData.delete(id);
      return newData;
    });
  };

  return (
    <Stack direction={"column"} spacing={2}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton onClick={handleBack} size="small">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6">
            These Cases Need to be Unassigned
          </Typography>
        </Stack>
        <Button
          variant="contained"
          color="primary"
          onClick={handleUnassign}
          disabled={unassigning}
        >
          {unassigning ? "Unassigning..." : "Unassign All"}
        </Button>
      </Stack>
      <CasesListTable data={data} onRemoveCase={handleRemoveSelectedCase} />
    </Stack>
  );
};
